import { type SerializedStyles, css } from '@emotion/react';
import { Flex, desktopFirstMediaQuery } from '@inflearn/ds-react-next';
import type { ReactNode } from 'react';

type DeviceItemLayoutProps = {
  leading: ReactNode;
  content: ReactNode;
  action?: ReactNode;
  styleWrapper?: SerializedStyles;
};

export function DeviceItemLayout({
  leading,
  content,
  action,
  styleWrapper,
}: DeviceItemLayoutProps) {
  return (
    <Flex
      component="li"
      bg="white"
      w="100%"
      px={24}
      py={24}
      mb={12}
      gap={16}
      align="center"
      styles={{
        root: css([
          {
            borderRadius: 16,
            border: '1px solid #E9ECEF',
            [desktopFirstMediaQuery.mobile]: {
              '&&': {
                padding: 20,
                gap: 12,
                '.leading': {
                  width: 32,
                  height: 32,
                },
              },
            },
          },
          styleWrapper,
        ]),
      }}
    >
      <Flex
        w={48}
        h={48}
        align="center"
        justify="center"
        styles={{
          root: { borderRadius: 12 },
        }}
        className="leading"
      >
        {leading}
      </Flex>
      <Flex
        direction="column"
        styles={{
          root: { flex: 1, minWidth: 0 },
        }}
      >
        {content}
      </Flex>
      {action ?? null}
    </Flex>
  );
}
